// extracted by mini-css-extract-plugin
export var catalogControls = "style-module--catalogControls--c84f2";
export var filters = "style-module--filters--9dc16";